/**
 * Map between CSS box coordinates and the letterboxed video content
 * when the video uses object-fit: contain.
 */

export function getContainRect(videoEl) {
  if (!videoEl) return null;
  const { videoWidth, videoHeight, clientWidth, clientHeight } = videoEl;
  if (!videoWidth || !videoHeight || !clientWidth || !clientHeight) {
    return { x: 0, y: 0, w: clientWidth || 0, h: clientHeight || 0 };
  }

  const videoRatio = videoWidth / videoHeight;
  const boxRatio = clientWidth / clientHeight;

  let w;
  let h;
  let x;
  let y;

  if (boxRatio > videoRatio) {
    h = clientHeight;
    w = h * videoRatio;
    x = (clientWidth - w) / 2;
    y = 0;
  } else {
    w = clientWidth;
    h = w / videoRatio;
    x = 0;
    y = (clientHeight - h) / 2;
  }

  return { x, y, w, h };
}

/** Client coords relative to video element → normalized 0–1 in content area. */
export function clientToNormalized(videoEl, clientX, clientY) {
  const rect = getContainRect(videoEl);
  if (!rect || rect.w <= 0 || rect.h <= 0) return null;

  const box = videoEl.getBoundingClientRect();
  const localX = clientX - box.left;
  const localY = clientY - box.top;

  const nx = (localX - rect.x) / rect.w;
  const ny = (localY - rect.y) / rect.h;

  if (nx < 0 || nx > 1 || ny < 0 || ny > 1) return null;
  return { x: nx, y: ny };
}

/** Normalized 0–1 → pixel coords inside the video element's box. */
export function normalizedToPixels(videoEl, nx, ny) {
  const rect = getContainRect(videoEl);
  if (!rect) return null;
  return {
    x: rect.x + nx * rect.w,
    y: rect.y + ny * rect.h,
  };
}

export function normalizedRadiusToPixels(videoEl, nr) {
  const rect = getContainRect(videoEl);
  if (!rect) return 0;
  return nr * Math.min(rect.w, rect.h);
}
